var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "20 5 90 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.09383104583734009,0,0,0.09383104583734009,16.387504735262407,16.481335781099748)",
    fill: "var(--main-text-color)"
  }, /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "696.7,239.6 508.5,37.5 508.5,441.7 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "822.2,454.8 832.1,178.8 546.2,464.6 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "758.9,695.7 961,507.5 556.8,507.5 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "543.7,821.2 819.7,831.1 533.9,545.2 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "302.8,757.9 491,960 491,555.8 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "177.3,542.7 167.4,818.7 453.3,532.9 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "240.6,301.8 38.5,490 442.7,490 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    points: "455.8,176.3 179.8,166.4 465.6,452.3 ",
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "st0",
    cx: 502.7,
    cy: 497,
    r: 31.4,
    style: {
      stroke: "#59636e",
      strokeWidth: 1.1669,
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.543417de00998f9f56ad7e150836ced0.svg";
export { ForwardRef as ReactComponent };